import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TextAreaFieldWUT } from '../../../ui/text-area-field';
export const TextAreaWUT = (props)=>{
    const fieldType = FIELD_TYPES.TEXT_AREA;
    return /*#__PURE__*/ React.createElement(TextAreaFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=text-area-wut.js.map